import React from "react";

const WeddingDiamond = React.forwardRef(function WeddingDiamond(
  { size = 24, color = "currentColor", strokeWidth = 1.5, className = "", ...props },
  ref
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M2 9 L7 3 H17 L22 9 L12 22 Z" />
      <path d="M2 9 H22" />
      <path d="M7 3 L10 9" />
      <path d="M17 3 L14 9" />
      <path d="M10 9 L12 22" />
      <path d="M14 9 L12 22" />
    </svg>
  );
});

export default WeddingDiamond;
